module.exports = __webpack_public_path__ + "static/media/alessandro-boccanelli.7aa4151d.jpg";